import { render, staticRenderFns } from "./department.bak.vue?vue&type=template&id=39e5e65b&scoped=true&"
import script from "./department.bak.vue?vue&type=script&lang=js&"
export * from "./department.bak.vue?vue&type=script&lang=js&"
import style0 from "./department.bak.vue?vue&type=style&index=0&id=39e5e65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5e65b",
  null
  
)

export default component.exports